class ProductStep extends HTMLElement {
  constructor() {
    super()

    this.addEventListener('change', this.changeHandler.bind(this))

    this.isSubPage = !!this.dataset.productHandles
    if (!this.isSubPage) return

    const { parentStepName, productHandles } = this.dataset
    this.parentInputs = productHandles
      .split(",")
      .map(handle => document.querySelector(`input[data-step-name="${parentStepName}"][data-product-handle="${handle}"]`))
      .filter(Boolean)
  }

  initParentNodesListeners() {
    if (!this.isSubPage || !this.parentInputs.length) return

    this.changeParentHandler()
    this.parentInputs[0].closest(".step__products").addEventListener("change", this.changeParentHandler.bind(this))
  }

  changeParentHandler() {
    const activeParentInput = this.parentInputs.find(input => input.checked && !input.closest("product-step")?.classList.contains("hidden"))

    this.classList.toggle("hidden", !activeParentInput)

    this.querySelectorAll(".step__products input").forEach(input => {
      input.disabled = !activeParentInput || input.hasAttribute("data-sold-out")
    })
    this.querySelector("input[data-product-handle]")?.dispatchEvent(new Event('change', { bubbles: true }));
  }

  changeHandler() {
    this.inputs = this.inputs || this.querySelectorAll("input[data-product-handle]")

    this.inputs.forEach(input => {
      const { nextElementSibling: propertyInput } = input

      if (propertyInput?.tagName == "INPUT") {
        propertyInput.disabled = input.disabled || !input.checked
      }

      this.syncNodeQuantity(input)
    })
  }

  syncNodeQuantity(input) {
    const node = input.closest(".product-node")
    const quantityElement = node?.querySelector("[data-node-quantity]")
    if (!quantityElement) return

    const isActive = input.checked && !input.disabled

    quantityElement.classList.toggle("hidden", !isActive)
    quantityElement.querySelector("input").disabled = !isActive

    this.updateNodePrice(node)
  }

  getNodeQuantity(node) {
    const quantityInput = node?.querySelector("[data-node-quantity] input")

    if (!quantityInput || quantityInput.disabled) return 1

    return Math.max(+quantityInput.value || 1, +quantityInput.min || 1)
  }

  updateNodePrice(node) {
    const priceElement = node.querySelector("[data-node-price]")
    if (!priceElement) return

    priceElement.innerHTML = window.Shopify.formatMoney(+priceElement.dataset.unitPrice * this.getNodeQuantity(node))
  }

  get price() {
    const checkedInputs = this.querySelectorAll(`[name^='items[']:checked`)

    return [...checkedInputs].reduce((total, input) => {
      return total + +input.dataset.productPrice * this.getNodeQuantity(input.closest(".product-node"))
    }, 0) || 0
  }
}

class ProductSteps extends HTMLElement {
  constructor() {
    super()

    this.priceDetails = document.querySelector("#ProductPriceDetails")
    this.steps = this.querySelectorAll("product-step")

    if (!this.steps && !this.priceDetails) return

    this.setProductsIndex()
    this.steps.forEach(step => {
      step.initParentNodesListeners()
      step.changeHandler()
    })

    this.addEventListener('change', () => {
      this.updatePriceDetails()
    })
    this.updatePriceDetails()
  }

  updatePriceDetails() {
    this.priceElements = this.priceElements || {
      optionsAmounts: document.querySelectorAll("[data-option-amount]"),
      totals: document.querySelectorAll("[data-total-price]")
    }

    const { productPrice } = this.priceDetails.dataset

    const optionAmount = [...this.steps].reduce((total, step) => {
      return total + (step.classList.contains("hidden") ? 0 : +step.price);
    }, 0)

    this.priceElements.optionsAmounts.forEach(optionsAmountElement => {
      optionsAmountElement.innerHTML = window.Shopify.formatMoney(optionAmount)
    })
    this.priceElements.totals.forEach(totalElement => {
      totalElement.innerHTML = window.Shopify.formatMoney(optionAmount + +productPrice)
    })
  }

  setProductsIndex() {
    let index = 1
    this.steps.forEach(step => {
      const isMultiproducts = step.hasAttribute("data-multiproducts")

      step.querySelectorAll("input[data-product-handle]").forEach(input => {
        const { nextElementSibling: propertyInput } = input

        input.setAttribute("name", `items[${index}][id]`)
        input.checked = input.hasAttribute("checked")

        if (propertyInput && propertyInput.tagName == "INPUT") {
          propertyInput.setAttribute("name", `items[${index}]properties[group_id]`)
        }

        const quantityInput = input.closest(".product-node")?.querySelector("[data-node-quantity] input")
        if (quantityInput) {
          quantityInput.setAttribute("name", `items[${index}][quantity]`)
        }

        if (isMultiproducts) index++
      })
      index++
    })
  }
}

(function () {
  checkHistory()
  initGallerySwiper()
  initDetailsTabs()
  initCustomElements()
  initAnchorLink()
  initLivePhotoTab()

  function initGallerySwiper() {
    const gallerySelector = document.currentScript.getAttribute('data-target');
    const galleryThumbnailsSelector =
      document.currentScript.getAttribute('data-second-target');

    const gallerySlider = new Swiper(gallerySelector, {
      direction: 'vertical',
      spaceBetween: 20,
      slidesPerView: 'auto',
      freeMode: true,
      watchSlidesProgress: true,
    });

    const galleryThumbnailsSlider = new Swiper(galleryThumbnailsSelector, {
      spaceBetween: 10,
      thumbs: {
        swiper: gallerySlider,
      },
      pagination: {
        el: '.swiper-pagination--product',
      },
      breakpoints: {
        769: {
          slidesPerView: 1,
        },
        0: {
          slidesPerView: 'auto',
        },
      },
    });
  }
  function initDetailsTabs() {
    const tabsElement = document.querySelector("#ProductTabs")
    const tabsContent = document.querySelectorAll("[data-tab-content-type]")

    if (!tabsElement || !tabsContent.length) return

    tabsElement.addEventListener("change", (event) => {
      tabsContent.forEach(content => {
        const { tabContentType } = content.dataset
        content.toggleAttribute('aria-hidden', tabContentType !== event.target.value)
      })
    })
  }

  function initLivePhotoTab() {
    const liveGalleryButton = document.querySelector('.live-photos__button--js');
    const calculationButton = document.querySelector('.calculation__button--js');
    const productTabsDetails = document.querySelectorAll('[data-tab-content-type]');
    const dataContentLivePhotos = document.querySelector('[data-tab-content-type="live-photos"]');
    const dataContentCalculation = document.querySelector('[data-tab-content-type="cost-calculation"]')
    const calculationInput = document.querySelector('input[value="cost-calculation"]');
    const liveGalleryInput = document.querySelector('input[value="live-photos"]');

    calculationButton?.addEventListener('click', () => {
      calculationInput.checked = true;

      if (!productTabsDetails) return;

      productTabsDetails.forEach(tab => {
        if (window.innerWidth >= 749) {
          tab.setAttribute('aria-hidden', 'true');
          if (tab.getAttribute('data-tab-content-type') === 'cost-calculation') {
            tab.removeAttribute('aria-hidden');
          }

          scrollToSection(false, 200);
          return
        } else {
          const accordion = tab.querySelector('accordion-compact')
          accordion.setAttribute('aria-expanded', 'false');
          if (tab.getAttribute('data-tab-content-type') === 'cost-calculation') {
            accordion.setAttribute('aria-expanded', 'true');

            setTimeout(() => scrollToSection(accordion, 0), 550);
          }
        }
      })

      function scrollToSection(item, offsetValue) {
        const scrollBlock = item ? item : dataContentCalculation
        const scrollTo = scrollBlock.offsetTop - offsetValue;

        window.scrollTo({
          top: scrollTo,
          behavior: 'smooth'
        });
      }
    })

    liveGalleryButton?.addEventListener('click', () => {
      liveGalleryInput.checked = true

      if (!productTabsDetails) return

      productTabsDetails.forEach(tab => {

        if (window.innerWidth >= 749) {
          tab.setAttribute('aria-hidden', 'true');
          if (tab.getAttribute('data-tab-content-type') === 'live-photos') {
            tab.removeAttribute('aria-hidden');
          }

          scrollToSection(false, 200)
          return
        } else {
          const accordion = tab.querySelector('accordion-compact')
          accordion.setAttribute('aria-expanded', 'false');
          if (tab.getAttribute('data-tab-content-type') === 'live-photos') {
            accordion.setAttribute('aria-expanded', 'true');

            setTimeout(() => scrollToSection(accordion, 0), 550);
          }
        }

      });

      function scrollToSection(item, offsetValue) {
        const scrollBlock = item ? item : dataContentLivePhotos
        const scrollTo = scrollBlock.offsetTop - offsetValue;

        window.scrollTo({
          top: scrollTo,
          behavior: 'smooth'
        });
      }
    })
  }

  function initCustomElements() {
    customElements.define('product-step', ProductStep);
    customElements.define('product-steps', ProductSteps);
  }
  function initAnchorLink() {
    const calcElement = document.querySelector('[data-tab-content-type="cost-calculation"]')

    if (!calcElement) return

    document.querySelector("[data-product-anchor-link]")?.addEventListener("click", (event) => {
      event.preventDefault()

      const inputTabOpener = document.querySelector('[name="productDetails"]')
      const accordionTabOpener = calcElement.querySelector('accordion-compact')

      if (inputTabOpener) {
        inputTabOpener.checked = true
        inputTabOpener.dispatchEvent(new Event('change', { bubbles: true }));
      }

      accordionTabOpener?.toggle(false)

      const calcPosition = calcElement.offsetTop - 200;
      window.scrollTo(0, calcPosition);
    })
  }

  function checkHistory() {
    const historyTraversal = window.persisted ||
      (window.performance && window.performance.navigation.type === 2);

    if (historyTraversal) {
      window.location.reload();
    }
    if (performance.navigation.type == 2) {
      location.reload(true);
    }
  }
})();